module.exports = __webpack_public_path__ + "img/banner1.81f817c4.jpg";